module.exports = __webpack_public_path__ + "img/img-6.52d3e479.jpg";